import { c as _c } from "react/compiler-runtime";
import { useQuery } from '@tanstack/react-query';
import services from '@/services';
import type { ValidateAuthentication } from '@/services/surveyService';
import { emailRegex } from '@/utils/common';
export const useCanUserAnswerSurvey = t0 => {
  const $ = _c(17);
  const {
    surveyId,
    entryId,
    email,
    firstname,
    lastname,
    isPreview
  } = t0;
  let t1;
  if ($[0] !== email || $[1] !== firstname || $[2] !== isPreview || $[3] !== lastname || $[4] !== surveyId) {
    t1 = Boolean(surveyId) && Boolean(email && firstname && lastname) && emailRegex.test(email) && !isPreview;
    $[0] = email;
    $[1] = firstname;
    $[2] = isPreview;
    $[3] = lastname;
    $[4] = surveyId;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const enabled = t1;
  let t2;
  let t3;
  if ($[6] !== email || $[7] !== entryId || $[8] !== firstname || $[9] !== lastname || $[10] !== surveyId) {
    t2 = async () => {
      const canUserAnswerSurvey = await services.survey.validateAuthentication({
        surveyId,
        entryId,
        email,
        firstname,
        lastname
      });
      return canUserAnswerSurvey;
    };
    t3 = ["canUserAnswerSurvey", surveyId, entryId, email, firstname, lastname];
    $[6] = email;
    $[7] = entryId;
    $[8] = firstname;
    $[9] = lastname;
    $[10] = surveyId;
    $[11] = t2;
    $[12] = t3;
  } else {
    t2 = $[11];
    t3 = $[12];
  }
  let t4;
  if ($[13] !== enabled || $[14] !== t2 || $[15] !== t3) {
    t4 = {
      queryFn: t2,
      queryKey: t3,
      enabled
    };
    $[13] = enabled;
    $[14] = t2;
    $[15] = t3;
    $[16] = t4;
  } else {
    t4 = $[16];
  }
  return useQuery(t4);
};